import React,{useState} from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import heroImg from "../img/page-bg.jpg";
import map from "../img/map.png";
import exploreSprite from "../img/explore.gif";
import gallerySprite from "../img/gallery.gif";
import nftSprite from "../img/makenft.gif";
import adSprite from "../img/ad.gif";
import {LinkContainer} from 'react-router-bootstrap';
import Adspace from '../components/adspace';


const bgStyle = {
  width: '100vw',
  height: '100vh',
  objectFit:'cover',
  position: 'fixed',
  left:'0'
};
const contentStyle = {
  position: 'relative',
  padding:'50px 0'
};

const mapStyle = {
  position:'relative',
  maxWidth:'800px',
  margin:'0 auto'
}

const explore = {
  left:'40%',
  top:'32%',
  position:'absolute',
  cursor:'pointer',
  display:'block',
  zIndex:'5',
  overflow:'hidden'
}
const gallery = {
  left:'9.6%',
  top:'74.3%',
  position:'absolute',
  cursor:'pointer',
  display:'block',
  zIndex:'5',
  overflow:'hidden'
}
const nft = {
  left:'12.8%',
  top:'57.3%',
  position:'absolute',
  cursor:'pointer',
  display:'block',
  zIndex:'5',
  overflow:'hidden'
}
const ad = {
  left:'63%',
  top:'61%',
  position:'absolute',
  cursor:'pointer',
  display:'block',
  zIndex:'5',
  overflow:'hidden'
}

const Map = () => {
  const [openModal,setOpenModal] = useState(false);
  return (
    <div className="container">
      <img style={bgStyle} src={heroImg} alt="heroImg" />
    	<div style={contentStyle} className="content-wrapper">
        <div style={mapStyle}><img className="mapImg" src={map} width="100%"/>
          <a class="rim-hotspot hExplore" style={explore}>
          <LinkContainer to="/explore"><img className="sprite explore" alt="explor" src={exploreSprite}/></LinkContainer>
          </a>
          <a class="rim-hotspot hGallery" style={gallery}>
          <LinkContainer to="/gallery"><img className="sprite gallery" alt="gall" src={gallerySprite}/></LinkContainer>
          </a>
          <a class="rim-hotspot hNFT" style={nft}>
          <LinkContainer to="/makeNFT"><img className="sprite nft" alt="nft" src={nftSprite}/></LinkContainer>
          </a>
          <a onClick={()=>{
            setOpenModal(true);
            }} class="rim-hotspot hAd" style={ad}>
            <img className="sprite ad" alt="ads" src={adSprite}/>
          </a>
          {openModal && <Adspace closeModal={setOpenModal}/>}
        </div>
      </div>
    </div>
  );
};

export default Map;
